import useBusinessPostApi from '../../lib/useBusinessPostApi.js';
import { useEffect, useState } from 'react';
import * as Toast from '../../lib/Toast.js';
import Loading from '../Loading';
import { ucfirst } from '../../lib/Utils.js';
import Modal from '../Modal';

function isHtml(key, action) {
    return key === 'body' && action === 'email';
}

const Preview = ({ settings, action, schema, isOpen, onClose }) => {
    const { save: getPreview, isSaving: isLoading } =
        useBusinessPostApi(`/flows/preview`);

    const [preview, setPreview] = useState({});

    useEffect(() => {
        if (!isOpen) return;

        getPreview({
            action: action,
            settings: settings,
            schema: schema,
        })
            .then(result => {
                setPreview(result);
            })
            .catch(err => {
                Toast.error('Failed to load preview');
            });
    }, [JSON.stringify(settings), isOpen]);

    return (
        <Modal onClose={onClose} isOpen={isOpen} widthClass="lg:min-w-[800px]">
            {isLoading && <Loading />}
            {!isLoading && (
                <div>
                    {Object.keys(preview).map(key => (
                        <div key={key} className="mb-4">
                            <div className="panel-label">{ucfirst(key)}</div>

                            <div className="panel p-4 html-preview">
                                {isHtml(key, action) && (
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: preview[key],
                                        }}
                                    />
                                )}
                                {!isHtml(key, action) && preview[key]}
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </Modal>
    );
};

export default Preview;
